import { firstSeenAt, readSavedChart } from './savedChart';

const RETURNING_AFTER = 30 * 60 * 1000;

let segment = null;

// Only the visitor segment and a tool name are sent. Birth details and
// questions never leave the page in an analytics event.
function visitorSegment() {
  if (!segment) {
    segment = {
      visitor: Date.now() - firstSeenAt() > RETURNING_AFTER ? 'returning' : 'new',
      saved_chart: readSavedChart() ? 'yes' : 'no',
    };
  }
  return segment;
}

export function noteHomeEvent(name, params = {}) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  if (navigator.userAgent === 'ReactSnap') return;
  try {
    window.gtag('event', name, { ...visitorSegment(), ...params });
  } catch {
    // Analytics must never break the page.
  }
}

export function noteHomeClick(tool, section, language) {
  noteHomeEvent('home_tool_click', { tool, section, language });
}
